<template>
  <div class="ring" style="text-align: center">
    <canvas id="tutorial" width="164" height="164"></canvas>
    <div class="desc-content">
      <div class="txt">累计收益</div>
      <span class="total-num">￥<span class="num">{{ totalNum }}</span></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    totalNum: {
      type: Number,
    },
    canExtractNum: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.drawRing();
  },
   watch: {
    canExtractNum: {
      immediate: true,
      handler() {
        this.drawRing();
      }
    },
    totalNum:{
      immediate: true,
      handler() {
        this.drawRing();
      }
    }
  },
  methods: {
    drawRing() {
      let radius = 75; //外环半径
      let thickness = 6; //圆环厚度
      let innerRadius = radius - thickness; //内环半径
      let startAngle = -90; //开始角度
      let endAngle = 180; //结束角度
      let x = 0; //圆心x坐标
      let y = 0; //圆心y坐标
      let total = parseInt(this.totalNum * 100); //总金额
      let now = parseInt(this.canExtractNum * 100); //可提现金额
      let width = 164;
      let height = 164;
      //测试数据
      // let total = 0.42 *100;
      // let now =0.21 * 100;
      let defaultColor =  total>0?'#30B5FF':'#6E6E6E'; 
      // let {canvas,ctx } = this.createCanvas(164,164,window.devicePixelRatio || 1) ; 
      let scale = window.devicePixelRatio || 1;
      const canvas = document.getElementById('tutorial');
      const ctx = canvas.getContext("2d");
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      canvas.width = width * scale;
      canvas.height = height * scale;
      ctx.translate(canvas.width / 2, canvas.height / 2); //将绘图原点移到画布中央
      ctx.scale(scale, scale);              
      ctx.rotate(angle2Radian(225)); //将画布旋转225度
      
      ctx.fillStyle = defaultColor; //初始填充颜色
      renderRing(startAngle, endAngle);

      //渲染函数
      function renderRing(startAngle, endAngle) {
        ctx.beginPath();

        //绘制外环
        ctx.arc(x, y, radius, angle2Radian(startAngle), angle2Radian(endAngle));

        //计算外环与内环第一个连接处的中心坐标
        let oneCtrlPoint = calcRingPoint(x, y, innerRadius + thickness / 2, endAngle);

        //绘制外环与内环第一个连接处的圆环
        ctx.arc(
          oneCtrlPoint.x,
          oneCtrlPoint.y,
          thickness / 2,
          angle2Radian(-90),
          angle2Radian(270)
        );

        // //绘制内环
        ctx.arc(x, y, innerRadius, angle2Radian(endAngle), angle2Radian(startAngle), true);

        //计算外环与内环第二个连接处的中心坐标
        let twoCtrlPoint = calcRingPoint(x, y, innerRadius + thickness / 2, startAngle);

        //绘制外环与内环第二个连接处的圆环
        ctx.arc(
          twoCtrlPoint.x,
          twoCtrlPoint.y,
          thickness / 2,
          angle2Radian(-90),
          angle2Radian(270)
        );

        ctx.fill();
        // ctx.stroke()
      }

      //计算圆环上点的坐标
      function calcRingPoint(x, y, radius, angle) {
        let res = {};
        res.x = x + radius * Math.cos((angle * Math.PI) / 180);
        res.y = y + radius * Math.sin((angle * Math.PI) / 180);
        return res;
      }

      //弧度转角度
      function radian2Angle(radian) {
        return (180 * radian) / Math.PI;
      }

      //角度转弧度
      function angle2Radian(angle) {
        return (angle * Math.PI) / 180;
      }

      //进度条颜色
      var lingrad = ctx.createLinearGradient(0, 0, 150, 0);
      let barColor =  total>0?'#F8B900':'#6E6E6E';
      lingrad.addColorStop(0, barColor);
      lingrad.addColorStop(1, '#fff');
      ctx.fillStyle = lingrad;

      //开始绘画
      let tempAngle = startAngle;
      let percent =0;
      if(total>0){
         percent= now / total; //百分比
      }
      let twoEndAngle = percent * 270 + startAngle;
      let step = (twoEndAngle - startAngle) / 80;
      // let numberSpan = document.querySelector(".numberOne");
      let inter = setInterval(() => {
        if (tempAngle > twoEndAngle) {
          clearInterval(inter);
        } else {
          // numberSpan.innerText = parseInt(percent * 100);
          tempAngle += step;
        }
        renderRing(startAngle, tempAngle);
      }, 20);
    },
  },
};
</script>
<style lang="less">
.ring {
  margin-top: 20px;
  position: relative;
  .desc-content {
    position: absolute;
    top: 48%;
    left: 50%;
    transform: translate(-50%, -50%);
    .txt {
      font-size: 28px;
      font-weight: 400;
      color: #ffdcb0;
    }
    .total-num {
      font-size: 30px;
      color: #ffdcb0;
      line-height: 42px;
      .num{
        font-size: 40px;
        font-family: HarmonyOS_Sans_SC_Bold;
      }
    }
  }
}
</style>
